import { useState } from "react"
import styles from "./styles.module.css"
import { Dropdown } from "primereact/dropdown"

function DatePicker({onMonthChange, onYearChange, defaultMonth = null, defaultYear = null}){
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth();
    const currentYear = currentDate.getFullYear();
    const [selectedMonth, setSelectedMonth] = useState(defaultMonth ?? currentMonth);
    const [selectedYear, setSelectedYear] = useState(defaultYear ?? currentYear);

    const months = [
        { value: 0,  name: "January" },
        { value: 1,  name: "February" },
        { value: 2,  name: "March" },
        { value: 3,  name: "April" },
        { value: 4,  name: "May" },
        { value: 5,  name: "June" },
        { value: 6,  name: "July" },
        { value: 7,  name: "August" },
        { value: 8,  name: "September" },
        { value: 9,  name: "October" },
        { value: 10, name: "November" },
        { value: 11, name: "December" }
    ];

    const years = Array.from({ length: 5 }, (_, index) => ({
        value: currentYear - index,
    }));

    function handleMonthChange(e){
        setSelectedMonth(e.value)
        onMonthChange?.(e.value)
    }

    function handleYearChange(e){
        setSelectedYear(e.value)
        onYearChange?.(e.value)
    }

    return(
        <div className={styles.container}>
            <Dropdown
                value={selectedMonth}
                onChange={handleMonthChange}
                options={months}
                optionLabel="name"
                optionValue="value"
                placeholder="Select a month"
                className={styles.dropdown}
            />
            <Dropdown
                value={selectedYear}
                onChange={handleYearChange}
                options={years}
                optionLabel="value"
                optionValue="value"
                placeholder="Select a year"
                className={styles.dropdown}
            />
        </div>
    )
}   

export default DatePicker;